import qs from 'qs';
import Ax, {Common, Download, Root} from '@/api/Ax';

export const login = {
  login: (params) => Ax.post('login', qs.stringify(params), {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
  }).then(res => res.data),
  logout: () => Ax.get('logout').then(res => res.data),
  getUserInfo: () => Ax.get('user/info').then(res => res.data.data),
  smsSend: (params) => Common.post('sms/verify', qs.stringify(params), {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
  }).then(res => res.data),
  smsSendNoVerify: (params) => Common.post('sms/send', qs.stringify(params), {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
  }).then(res => res.data),
  userResetPassword: (params) => Common.get('resetPassword', {params}).then(res => res.data),
  /**
   * 重置密码
   * @param params
   */
  resetPassword: (params) => Ax.post('user/reset/pass/v1', qs.stringify(params), {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
  }).then(res => res.data),
};

export const scorepoint = {
  // 获得所有的建模员
  getWorkers: () => Ax.get('user/workers').then(res => res.data),

  // 新建建模员账号
  createWorker: (params) => Ax.post('user/workers/new', qs.stringify(params), {
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
  }).then(res => res.data),

  // 重置建模员账号密码
  resetPassword: (params) => Ax.post('user/reset/pass/v1', qs.stringify(params), {
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
  }).then(res => res.data),

  // 设置建模人员工具权限
  setToolPermission: (params) => Ax.post('user/reset/toolpermission/v1', qs.stringify(params), {
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
  }).then(res => res.data),

  // 获取绩点历史
  getHistories: (workerid) => Ax.get('user/workers/scorepointhistory?workerid=' + workerid).then(res => res.data),

  // 添加绩点记录
  addRecord: (params) => Ax.post('user/workers/addscorepoint', qs.stringify(params), {
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
  }).then(res => res.data),

  // 读取所有的工序模板
  getActionTemplates: () => Ax.get('/taskactiontemplates').then(res => res.data),

  // 删除一个工序模板
  deleteActionTemplate: (taskType) => Ax.post('/taskactiontemplates/delete', qs.stringify({taskType}), {
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
  }).then(res => res.data),

  // 修改一个工序模板
  commitActionTemplate: (taskType, actions) => Ax.post('/taskactiontemplates/save', {taskType, actions}).then(res => res.data),

  // 查询当前订单的任务分配
  getActionAndUsers: (taskId) => Ax.get('/taskactions/' + taskId).then(res => res.data),

  // 为工序分配人员
  assignUser: (taskId, actions) => Ax.post('/taskactions/' + taskId + '/assign', actions).then(res => res.data),
};

export const file = {
  getToken: () => Ax.get('utils/osssts').then(res => res.data.data),
};

export const task = {
  create: (params) => Ax.post('task/create', params).then(res => res.data),
  removeCreateFile: (params) => Ax.post('task/create/file/remove', params).then(res => res.data),
  submit: (id) => Ax.get(`task/submit/${id}`).then(res => res.data),
  setTaskTags: (id, tags) => Ax.post(`task/${id}/tags`, {tags}).then(res => res.data),
  fetchById: (id) => Ax.get(`task/${id}`).then(res => res.data),
  fetchAll: (params) => Ax.post('task/list', params).then(res => res.data),
  fetchDraft: (params) => Ax.post('task/list/draft', params).then(res => res.data),
  fetchSubmitted: (params) => Ax.post('task/list/submitted', params).then(res => res.data),
  fetchProcessing: (params) => Ax.post('task/list/processing', params).then(res => res.data),
  fetchFinished: (params) => Ax.post('task/list/finished', params).then(res => res.data),
  processStart: (id) => Ax.get(`task/process/start/${id}`).then(res => res.data),
  processRevert: (id) => Ax.get(`task/process/revert/${id}`).then(res => res.data),
  processFinish: (params) => Ax.post('task/process/finish', params).then(res => res.data),
  processEdit: (params) => Ax.post('task/process/edit', params).then(res => res.data),
  /**
   * 分配 处理人
   * @param taskId taskId
   * @param name name
   */
  allotProcessor: (taskId, name) => Ax.put(`task/allot/processor/${taskId}/${name}`).then(res => res.data),
  /**
   * 分配 重建组
   * @param taskId
   * @param name
   * @returns {Promise<T>}
   */
  allotProcessGroup: (taskId, name) => Ax.put(`task/allot/process_group/${taskId}/${name}`).then(res => res.data),

  /**
   * 更新 窗宽窗位 设置
   * @param params
   * @returns {*}
   */
  updateWW: (params) => Ax.post('task/preprocess/staging/ww', qs.stringify(params), {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
  }).then(res => res.data),

  removeProcessFile: (params) => Ax.post('task/process/file/remove', params).then(res => res.data),
  preprocessUpload: (params) => Ax.post('task/preprocess/staging/manual', params).then(res => res.data),
  modelUpload: (params) => Ax.post('task/process/model', params).then(res => res.data),
  fetchItemNamesOptions: (params) => Ax.get('item/list/name', params).then(res => res.data),
  doctorAdd: (params) => Ax.post('doctor/add', qs.stringify(params), {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
  }).then(res => res.data),
  doctorDetail: (params) => Ax.get('doctor/detail', {params}).then(res => res.data),
  departmentAdd: (params) => Ax.post('department/add', params).then(res => res.data),
  hospitalAgentBind: (params) => Ax.post('hospital/agent/bind', qs.stringify(params), {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
  }).then(res => res.data),
  departmentDelete: (params) => Ax.post('department/delete', qs.stringify(params), {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
  }).then(res => res.data),
  agentDelete: (params) => Ax.post('agent/delete', qs.stringify(params), {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
  }).then(res => res.data),
  doctorDelete: (params) => Ax.post('doctor/delete', qs.stringify(params), {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
  }).then(res => res.data),
  hospitalDelete: (params) => Ax.post('hospital/agent/delete', qs.stringify(params), {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
  }).then(res => res.data),
  departmentHospitalList: (params) => Ax.get('department/hospital/list', {params}).then(res => res.data),
  hospitalAgentList: (params) => Ax.get('hospital/agent/list', {params}).then(res => res.data),
  doctorDepartmentList: (params) => Ax.get('doctor/department/list', {params}).then(res => res.data),
  departmentListName: (params) => Ax.get('department/list/name', {params}).then(res => res.data),
  hospitalListName: (params) => Ax.get('hospital/list/name', {params}).then(res => res.data),
  agentUserSearch: (params) => Ax.get('agent/user/search', {params}).then(res => res.data),
  hospitalDetail: (params) => Ax.get('hospital/detail', {params}).then(res => res.data),
  agentDetail: (params) => Ax.get('agent/detail', {params}).then(res => res.data),
  agentMoneyDetails: (params) => Ax.get('agent/moneydetails', {params}).then(res => res.data),
  agentMoneyChange: (params) => Ax.post('agent/moneychange', qs.stringify(params), {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  }).then(res => res.data),
  departmentDetail: (params) => Ax.get('department/detail', {params}).then(res => res.data),
  payItemList: (ID) => Ax.get(`item/list/${ID}`).then(res => res.data),
  updatePayItem: (params) => Ax.post('item/update', qs.stringify(params), {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  }).then(res => res.data),
  addPayItem: (params) => Ax.post('item/add', qs.stringify(params), {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  }).then(res => res.data),
  deletePayItem: (ID) => Ax.get(`item/delete/${ID}`).then(res => res.data),
  hospitalAdd: (params) => Ax.post('hospital/add', qs.stringify(params), {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
  }).then(res => res.data),
  hospitalAgentUpdate: (params) => Ax.post('hospital/agent/update', qs.stringify(params), {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
  }).then(res => res.data),
  areasList: (params) => Ax.get('areas/list', {params}).then(res => res.data),
  departmentUpdate: (params) => Ax.post('department/update', qs.stringify(params), {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
  }).then(res => res.data),
  doctorUpdate: (params) => Ax.post('doctor/update', qs.stringify(params), {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
  }).then(res => res.data),
  agentUpdate: (params) => Ax.post('agent/update', qs.stringify(params), {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
  }).then(res => res.data),
  hospitalUpdate: (params) => Ax.post('hospital/update', qs.stringify(params), {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
  }).then(res => res.data),
  hospitalAgentMine: (params) => Ax.get('hospital/agent/mine', {params}).then(res => res.data),
  agentList: (params) => Ax.get('agent/list', {params}).then(res => res.data),
  doctorList: (params) => Ax.get('doctor/list', {params}).then(res => res.data),
  logList: (params) => Ax.get('log/list', {params}).then(res => res.data),
  agentAdd: (params) => Ax.post('agent/add', qs.stringify(params), {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
  }).then(res => res.data),
  agentDisable: (params) => Ax.post('agent/disable', qs.stringify(params), {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
  }).then(res => res.data),
  departmentDisable: (params) => Ax.post('department/disable', qs.stringify(params), {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
  }).then(res => res.data),
  logEnableUser: (params) => Ax.post('log/enableUser', qs.stringify(params), {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
  }).then(res => res.data),
  logAddRemark: (params) => Ax.post('log/addRemark', qs.stringify(params), {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
  }).then(res => res.data),
  logUpdateLogLevel: (params) => Ax.post('log/updateLogLevel', qs.stringify(params), {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
  }).then(res => res.data),

  /**
   * 加载 重建类型数据
   */
  reconData: () => Ax.get(`task/recon`).then(res => res.data),
  /**
   * 加载 病种
   */
  diseaseData: () => Ax.get(`task/disease`).then(res => res.data),
  /**
   * 导出已完成订单数据
   * @param params
   */
  exportTaskInfo: (params) => Download.get(`task/export/v1`, {params}).then(res => res.data),
  /**
   * 更换代理商
   * @param params
   * @returns {*}
   */
  changeAgent: (params) => Ax.post('/department/agent/change/v1', qs.stringify(params), {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
  }).then(res => res.data),

  /**
   * 查询订单的活动记录
  */
  getActivities: (taskId) => Ax.get('/task/' + taskId + '/activities').then(res => res.data),

  /*
  * 订单合并/删除
  */
  mergeTask: (srcTaskId, destPublicOrderId, verify) => Ax.post('/task/merge', qs.stringify({srcTaskId, destPublicOrderId, verify})).then(res => res.data),

  agentPay: (srcTaskId, verify) => Ax.post('/task/agentpay', qs.stringify({srcTaskId, verify})).then(res => res.data),
  agentRefund: (srcTaskId, verify) => Ax.post('/task/agentrefund', qs.stringify({srcTaskId, verify})).then(res => res.data),

  /*
  请求重新生成viewer app文件
  */
  queryViewerApp: (taskId) => Ax.post('/task/query_viewer_app/' + taskId, qs.stringify({taskId})).then(res => res.data)
};

/**
 * 消息通知 相关 api
 * @type {{task: notice.task}}
 */
export const notice = {
  /**
   * task 任务 通知
   */
  task: () => Ax.get('notice/task/v1').then(res => res.data),
};
/**
 * stl 模型接口
 */
export const stl = {
  /**
   * 模型配置 列表
   */
  list: (params) => Root.post('/model/list/v1', qs.stringify(params), {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
  }).then(res => res.data),
  /**
   * 根据code 获取模型数据
   */
  code: (params) => Root.post('/model/code', params).then(res => res.data),
  /**
   * 模型 详情
   * @param id
   */
  detail: (id) => Root.get(`/model/detail/v1/${id}`).then(res => res.data),
  /**
   * 模型 删除
   * @param id
   */
  delete: (id) => Root.get(`/model/delete/v1/${id}`).then(res => res.data),
  /**
   * 模型 新增
   * @param params
   */
  add: (params) => Root.post('/model/add/v1', params).then(res => res.data),
  /**
   * 模型 修改
   * @param params
   */
  update: (params) => Root.post('/model/update/v1', params).then(res => res.data),

  /**
   * 模型 分组列表
   * @param params
   */
  listGroup: (params) => Root.post('/modelGroup/list/v1', qs.stringify(params), {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
  }).then(res => res.data),

  updateGroup: (params) => Root.post('/modelGroup/update/v1', params).then(res => res.data),
  addGroup: (params) => Root.post('/modelGroup/add/v1', params).then(res => res.data),
  deleteGroup: (id, orderId) => Root.get(`/modelGroup/delete/v1/${id}/${orderId}`).then(res => res.data),
  /**
   * 切换默认分组
   * @param params
   * @returns {*}
   */
  changeTmp: (params) => Root.post('/modelGroup/change/tmp/v1', qs.stringify(params), {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
  }).then(res => res.data),

};

export const refund = {
  /**
   * 订单列表
   * @param params
   * @returns {*}
   */
  list: (params) => Root.post('/refund/list/v1', params).then(res => res.data),
  /**
   * 退款
   * @param params
   * @returns {*}
   */
  refund: (params) => Root.get('/refund/wx/order/v1', {params}).then(res => res.data),
};



// WEBPACK FOOTER //
// ./src/api/index.js